import { MenuItem } from '@mui/material';
import type { PaymentTerm } from '@weft/types';
import { PAYMENT_TERMS } from '@weft/types';
import { entries, raiseUnreachable } from '@weft/utils';
import { VayuTextField } from 'apps/app/src/components/design/vayu-theme-components/VayuTextField';
import React from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

type PaymentTermDropdownProps = {
  productIndex: number;
  control: Control;
  defaultPaymentTerm?: PaymentTerm;
};

export const PaymentTermDropdown: React.FC<PaymentTermDropdownProps> = ({ productIndex, control, defaultPaymentTerm }) => {
  return (
    <Controller
      control={control}
      name={`fixedProducts.${productIndex}.paymentTerm`}
      render={({ field }) => (
        <VayuTextField
          label="Payment term"
          placeholder="Select payment term"
          select
          fullWidth
          focused
          {...field}
        >
          {entries(PAYMENT_TERMS).map(([key, value]) => (
            <MenuItem
              key={key}
              value={value}
              selected={value === defaultPaymentTerm}
            >
              {getPaymentTermLabel(value)}
            </MenuItem>
          ))}
        </VayuTextField>
      )}
    />
  );
};

function getPaymentTermLabel(paymentTerm: PaymentTerm) {
  switch (paymentTerm) {
    case PAYMENT_TERMS.Postpayment:
      return 'Postpaid';
    case PAYMENT_TERMS.Prepayment:
      return 'Prepaid';
    default:
      return raiseUnreachable(paymentTerm);
  }
}